import DotLoader from 'react-spinners/BeatLoader';
import { cn } from '../../utils/classNames';

const wrapperClasses = 'flex justify-center mt-60';

const XLoader = ({ className }) => (
  <div className={cn(wrapperClasses, className)}>
    <DotLoader
      color="var(--color-primary)"
      loading
      size={30}
      aria-label="Loading Spinner"
      data-testid="loader"
    />
  </div>
);

export default XLoader;
